module.exports = __webpack_public_path__ + "img/profile-demographic-inactive.a7a1e1c2.svg";